import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import { profileApi } from './profile';

export const brokerAccountsApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    createBrokerAccount: builder.mutation<
      SharesproApiResponse<boolean>,
      ApiCreateBrokerAccountRequest
    >({
      query: (data) => ({
        url: '/v3/finance/account/create',
        method: 'POST',
        sendToken: true,
        body: data,
      }),
    }),
    deleteBrokerAccount: builder.mutation<
      SharesproApiResponse<boolean>,
      number
    >({
      query: (id) => ({
        url: '/v3/finance/account/delete',
        method: 'DELETE',
        sendToken: true,
        params: {
          account_id: id,
        },
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            profileApi.util.updateQueryData(
              'fetchProfile',
              undefined,
              (draft) => {
                if (draft.brokerAccounts) {
                  draft.brokerAccounts = draft.brokerAccounts.filter(
                    (account) => account.id !== id
                  );
                }
              }
            )
          );
        } catch {}
      },
    }),
  }),
});

export const {
  useCreateBrokerAccountMutation,
  useDeleteBrokerAccountMutation,
} = brokerAccountsApi;
